import React from "react";
import { connect } from "react-redux";
import { saveNewPasswordAction } from "actions/user-settings-actions";
import { UserPasswordSettings } from "components/settings/user-password-settings";

const UserPasswordPage = (props) => <UserPasswordSettings { ...props } />;

const matchStateToProps = (state) => ({
  passwordDetails: state.userSettings.passwordDetails
});

const mapDispatchToProps = (dispatch) => ({
  onSavePassword: (passwordDetails) => dispatch(saveNewPasswordAction(passwordDetails))
});

export const UserPasswordContainer = connect(matchStateToProps, mapDispatchToProps)(UserPasswordPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/user-password-container.jsx